import { Button } from "antd";

const SubmitButton = ({
  ky,
  type,
  htmlType,
  submitName,
  className,
  onClick,
  loading,
}) => {
  return (
    <Button
      key={ky}
      type={type}
      htmlType={htmlType}
      className={className}
      onClick={onClick}
      loading={loading}
    >
      {submitName}
    </Button>
  );
};

export default SubmitButton;
